import _get from 'lodash/get';

export const getNavigationV2 = data =>
  data
    ? {
        entries: [data.entries.filter(element => element.entry.id !== 'Brand')],
      }
    : {
        entries: [],
      };

export const getNavigationV3 = data =>
  data
    ? {
        entries: data.map(group =>
          _get(group, 'entries', []).map(entry => {
            const subEntries = _get(entry, 'groups[0].entries', []);
            entry.groups = [];

            return {
              entry,
              subEntries,
            };
          }),
        ),
      }
    : {
        entries: [],
      };
